import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';

@Component({
    selector: 'app-employee-selection-filters',
    templateUrl: './employee-selection-filters.component.html',
    styleUrls: ['./employee-selection-filters.component.scss'],
    standalone: false
})
export class EmployeeSelectionFiltersComponent implements OnInit {

  EmployeSelectionFilterForm: UntypedFormGroup = this.formBuilder.group({
    BajasEmpresa: [false],
    EmpresaSelec: [true],
    Alarmas: [null],
    BajasOrdern: ['Trabajador']
  });

  alarmasOptions = [
    { text: 'Alarmas de bajas activas', value: '1' },
    { text: 'Alarmas de bajas del último año', value: '2' },
    { text: '3 o más bajas en los últimos 12 meses', value: 'B' },
    { text: 'Más de 100 días de baja en los últimos 12 meses', value: 'D' },
    { text: 'Baja no justificada en los últimos 2 años', value: 'A' },
    { text: 'Más de un 5,5% de absentismo en su historial', value: 'J' },
    { text: 'Previsión de alta superior a 2 meses', value: 'P' },
    { text: 'Baja por motivos de clima laboral o temas sociales', value: 'L' },
    { text: 'No presentados a revisión en baja actual', value: 'R' },
    { text: 'No presentados en baja de últimos 12 meses', value: 'S' },
    { text: 'No presentados en baja de últimos 24 meses', value: 'U' },
    { text: 'Solicitud de incapacidad permanente', value: 'I' },
    { text: 'Otras solicitudes de inspección', value: 'K' },
  ];

  constructor(public selectionService: SelectionGenericService,
    public formBuilder: UntypedFormBuilder) { }

  ngOnInit(): any {
    this.selectionService.employeeSelectionModal.EmpresaSelec = this.EmployeSelectionFilterForm.value.EmpresaSelec;
    this.selectionService.employeeSelectionModal.BajasOrdern = this.EmployeSelectionFilterForm.value.BajasOrdern;
  }

  public SetFilterValues(filterType: string, data: any = null): void {
    switch (filterType) {
      case 'bajasEmpresa':
        this.selectionService.employeeSelectionModal.BajasDeEmpresa = this.EmployeSelectionFilterForm.value.BajasEmpresa;
        break;

        case 'empresaSelec':
        this.selectionService.employeeSelectionModal.EmpresaSelec = this.EmployeSelectionFilterForm.value.EmpresaSelec;
        break;

      case 'alarmas':
        const alarmasArray = this.EmployeSelectionFilterForm.value.Alarmas;
        let alarmas = '';
        alarmasArray.forEach(alarma => {
          alarmas += alarma;
        });

        this.selectionService.employeeSelectionModal.Alarmas = alarmas;
        break;
      case 'Ordern':
        this.selectionService.employeeSelectionModal.Ordern = data.selectedValue;
        break;

      default:
        break;
    }
  }

}
